import { Dispatch, SetStateAction } from 'react';
import { useSingleTemplateData } from './useSingleTemplateData';
import {
  isBlocksTemplate,
  isCLITemplate,
  isDevCenterTemplate,
} from '../selectors/templateType-selectors';
import { ActiveModal } from '../components/TemplatePage/Modals/ModalRenderer';
import { usePageNavigate } from './usePageNavigate';

export type SetOpenModal = Dispatch<SetStateAction<ActiveModal>>;
export const useCloneTemplate = (setActiveModal: SetOpenModal) => {
  const { template } = useSingleTemplateData();
  const { openBlocksTemplateFlow } = usePageNavigate();
  if (isBlocksTemplate(template)) {
    return () => openBlocksTemplateFlow(template.id, template.title);
  } else if (isCLITemplate(template)) {
    return () => setActiveModal(ActiveModal.CLI);
  } else if (isDevCenterTemplate(template)) {
    return () => setActiveModal(ActiveModal.SELF_HOSTED);
  }
};
